import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { KeyDropLocationService } from '../../business-services/dealer-keyDrop-location.service';


@Injectable({ providedIn: 'root' })
export class EditKeydropLocationGuard  {

  constructor(
    private service: KeyDropLocationService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.service.KeydropLocationId) {
      return true;
    }
    return this.router.createUrlTree(['/keyDropLocation']);
  }
}
